import { c as _c } from "react/compiler-runtime";
import { IcoAt16 } from '@onefootprint/icons';
import { IconButton, Tooltip } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type MentionButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};
const MentionButton = t0 => {
  const $ = _c(11);
  const {
    onClick,
    disabled
  } = t0;
  const {
    t
  } = useTranslation("copilot");
  let t1;
  if ($[0] !== t) {
    t1 = t(_temp);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t(_temp2);
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== disabled || $[5] !== onClick || $[6] !== t2) {
    t3 = <IconButton aria-label={t2} className="rounded-full! max-md:size-8" icon={IcoAt16} variant="ghost" size="compact" onClick={onClick} disabled={disabled} />;
    $[4] = disabled;
    $[5] = onClick;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <Tooltip content={t1}>{t3}</Tooltip>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default MentionButton;
function _temp($) {
  return $.chat.mentionEntity;
}
function _temp2($_0) {
  return $_0.chat.mentionEntity;
}